import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

// Chakra imports
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDescription,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Table,
  Tbody,
  Icon,
  Text,
  Th,
  Thead,
  Tr,
  SimpleGrid,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  Center,
  Spinner,
  Select,
  Input,
  Textarea,

  //hooks
  useDisclosure,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";

// Data
import { tablesProjectData, tablesTableData } from "variables/general";

// Icons
import { AiFillCheckCircle } from "react-icons/ai";
import { useHistory, useLocation } from "react-router-dom";
import { getFileTempLink } from "service/kyc.service";
import { useFormik } from "formik";
import * as yup from "yup";
import GradientBorder from "components/GradientBorder/GradientBorder";
import { verifyUser } from "service/kyc.service";
import { getAllRoles } from "service/role.service";
import { releasePaymentUser } from "service/kyc.service";
import { ROLES_STATUS } from "constants";
import { assignRoleToUser } from "service/role.service";
import { useAppToast } from "utils/toastUtil";

export default function UserDetail() {
  const cancelRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [user, setUser] = useState(location?.state ?? null);
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState(null);
  const { showToast } = useAppToast();

  const getRoles = async () => {
    try {
      const roleLists = await getAllRoles();
      // console.log(roleLists.data);
      setRoles(roleLists.data);
    } catch (error) {
      console.log(error);
    }
  };

  const assignRole = async () => {
    try {
      const data = await assignRoleToUser(user.id, role);

      onClose();

      history.push("/admin/users");

      showToast({
        title: "Success!",
        description: "Role assigned",
        status: "success",
      });
    } catch (error) {
      console.log(error)
      showToast({
        title: "Failed!",
        description: error?.message ?? "Not Authorized",
        status: "error",
      });
    }finally{
      onClose();
    }
  };

  const matchingRole = roles.find((role) => role.id === user.role_id);

  useEffect(() => {
    if (user === null) history.push("/admin/users");
    else getRoles();
  }, []);

  // console.log(user, matchingRole)
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* Authors Table */}
      {user && user.profile && (
        <>
          <Card>
            <CardHeader p="6px 0px 22px 0px">
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                {user.profile.full_name ?? "User"} Information
              </Text>
            </CardHeader>
            <CardBody w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Full Name</Text>
                  <Text color={"white"}>{user.profile.full_name}</Text>
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Name</Text>
                  <Text color={"white"}>{user.profile.nickname}</Text>
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Email</Text>
                  <Text color={"white"}>{user.profile.contact_email}</Text>
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Phone</Text>
                  <Text color={"white"}>{user.profile.contact_phone}</Text>
                </VStack>
              </SimpleGrid>
            </CardBody>
          </Card>
          <Card mt={"6"}>
            <CardHeader p="6px 0px 22px 0px">
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                Role Information
              </Text>
            </CardHeader>
            <CardBody w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>User Role</Text>
                  {/* {matchingRole && <Text color={"white"}> {matchingRole.name}</Text>} */}
                  <Text color={"white"}>
                    {
                    ROLES_STATUS[user.role_id]
                  }
                  </Text>
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Select
                    py={"2"}
                    maxW={"300px"}
                    placeholder="Role"
                    bg={"white"}
                    fontSize={"xs"}
                    fontWeight={"bold"}
                    textTransform={"uppercase"}
                    value={role ?? ""}
                    onChange={(e) => {
                      setRole(e.target.value);
                    }}
                  >
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </Select>
                </VStack>
              </SimpleGrid>
            </CardBody>
          </Card>
          <Card mt={"6"}>
            <CardBody w={"full"}>
              <Center w={"full"}>
                <Button
                  bg={"red"}
                  color={"white"}
                  disabled={true}
                  // fontSize="10px"
                  type="submit"
                  w="100%"
                  maxW="350px"
                  h="45"
                  mb="20px"
                  mt="20px"
                  mx={"2"}
                  // isLoading={formik.isSubmitting}
                  // onClick={formik.submitForm}
                >
                  DEACTIVATE USER ACCOUNT
                </Button>
                <Button
                  // disabled={!!role}
                  variant="brand"
                  // fontSize="10px"
                  type="submit"
                  w="100%"
                  maxW="350px"
                  h="45"
                  mb="20px"
                  mt="20px"
                  mx={"2"}
                  textTransform={"uppercase"}
                  fontWeight={"bold"}
                  backgroundColor={"green.500"}
                  // isLoading={paymentSending}
                  onClick={onOpen}
                >
                  UPDATE ROLE
                </Button>
              </Center>
            </CardBody>
          </Card>
        </>
      )}

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Assign Role
            </AlertDialogHeader>

            <AlertDialogBody>Confirm set role?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="green"
                onClick={() => {
                  assignRole();
                  onClose;
                }}
                ml={3}
              >
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
}

/*
 <>
       
      </>

      <Modal isOpen={paymentComplete}>
        <ModalBody>Done!</ModalBody>
      </Modal>

      <Modal
        isOpen={isOpen}
        onClose={() => {
          setImagesLink(null);
          onClose();
        }}
        size={"3xl"}
        minH={"500px"}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          bg={
            "linear-gradient(10.84deg, rgba(80, 80, 80, 0.80) 59.3%, rgba(26, 31, 55, 0) 100%)"
          }
        >
           <ModalHeader>Modal Title</ModalHeader> 
           <ModalCloseButton /> 
          <ModalBody>
            {imagesLink?.loading ? (
              <Center>
                <Spinner />
              </Center>
            ) : imagesLink?.url ? (
              <Center>
                <Image alt={"user file"} src={imagesLink?.url?.link} />
              </Center>
            ) : (
              <Alert status="error">
                <AlertIcon />
                <AlertTitle>Oops link expired!</AlertTitle>
                <AlertDescription>Please try again later</AlertDescription>
              </Alert>
            )}
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      */
